(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.messages = [...this.querySelectorAll('[data-announcement]')];
      this.index = Math.max(0, this.messages.findIndex((m) => !m.hidden));
      this.querySelector('[data-announcement-prev]')?.addEventListener('click', () => this.go(-1, true));
      this.querySelector('[data-announcement-next]')?.addEventListener('click', () => this.go(1, true));
      this.addEventListener('shopify:block:select', (event) => {
        const i = this.messages.indexOf(event.target);
        if (i >= 0) this.show(i);
        this.stop();
      });
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
      this.watchChromeColor();
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      if (this.meta && this.meta.dataset.pageColor) this.meta.setAttribute('content', this.meta.dataset.pageColor);
    }

    /* The browser chrome (phone status bar area) follows whatever is painted at the top
       of the viewport: the bar color while any part of the bar is visible, the page color
       once the bar has scrolled away and the floating header sits at the top. Supporting
       browsers animate the change themselves. The inline script after the bar sets the
       initial color before first paint; this only handles scrolling. */
    watchChromeColor() {
      this.meta = document.querySelector('meta[name="theme-color"]');
      const barColor = this.dataset.themeColor;
      if (!this.meta || !barColor || !('IntersectionObserver' in window)) return;
      const pageColor = this.meta.dataset.pageColor || barColor;
      this.observer = new IntersectionObserver(([entry]) => {
        this.meta.setAttribute('content', entry.isIntersecting ? barColor : pageColor);
      });
      this.observer.observe(this);
    }

    start() {
      const seconds = Number(this.dataset.autoplay) || 0;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!seconds || reduced || this.messages.length < 2 || window.Shopify?.designMode) return;
      this.stop();
      this.timer = window.setInterval(() => this.go(1), seconds * 1000);
    }

    stop() {
      window.clearInterval(this.timer);
    }

    go(step, user) {
      if (user) this.stop();
      this.show((this.index + step + this.messages.length) % this.messages.length);
    }

    show(i) {
      this.messages.forEach((m, n) => (m.hidden = n !== i));
      this.index = i;
    }
  }
  if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["appointment-form"] && !Shopify.designMode) return;
  try {
    
  class AppointmentForm extends HTMLElement {
    connectedCallback() {
      this.preselectService();
      this.dateInput = this.querySelector('[data-date-input]');
      this.dateHint = this.querySelector('[data-date-hint]');
      this.dateInput?.addEventListener('change', () => this.checkDate());
    }

    preselectService() {
      const select = this.querySelector('[data-service-select]');
      if (!select || select.value) return;
      const wanted = new URLSearchParams(window.location.search).get('service');
      if (!wanted) return;
      const normalize = (value) =>
        value
          .toString()
          .trim()
          .toLowerCase()
          .replace(/[^\p{L}\p{N}]+/gu, '-')
          .replace(/^-+|-+$/g, '');
      const target = normalize(wanted);
      const match = [...select.options].find(
        (option) => option.value && (normalize(option.value) === target || option.dataset.key === target)
      );
      if (match) select.value = match.value;
    }

    checkDate() {
      if (!this.dateHint) return;
      this.dateHint.textContent = '';
      this.dateHint.classList.remove('is-warning');
      const value = this.dateInput.value;
      if (!value) return;
      const [year, month, day] = value.split('-').map(Number);
      const weekday = new Date(year, month - 1, day).getDay();
      const hours = (this.dataset.hours || '').split('|')[weekday] || '';
      const closedWord = this.dataset.closedWord;
      if (closedWord && hours.toLowerCase().includes(closedWord)) {
        this.dateHint.textContent = this.dataset.closedMessage || hours;
        this.dateHint.classList.add('is-warning');
      } else if (hours) {
        this.dateHint.textContent = hours;
      }
    }
  }
  if (!customElements.get('appointment-form')) customElements.define('appointment-form', AppointmentForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  class BeforeAfter extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.compare__range');
      if (!this.range) return;
      this.range.addEventListener('input', this.update);
      this.update();
    }

    update = () => {
      const value = this.range.value;
      this.style.setProperty('--position', `${value}%`);
      const template = this.range.dataset.valueTemplate;
      if (template) this.range.setAttribute('aria-valuetext', template.replace('[percent]', value));
    };
  }
  if (!customElements.get('before-after')) customElements.define('before-after', BeforeAfter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-gallery"] && !Shopify.designMode) return;
  try {
    
  class CommunityGallery extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.community-gallery__item')];
      this.dialog = this.querySelector(`#${CSS.escape(this.dataset.dialog)}`);
      this.stage = this.dialog?.querySelector('[data-stage]');
      this.counter = this.dialog?.querySelector('[data-counter]');
      this.counterTemplate = this.dialog?.querySelector('[data-counter-template]')?.innerHTML || '';
      this.batch = parseInt(this.dataset.batch, 10) || 12;
      this.limit = this.batch;
      this.filter = '';

      this.querySelectorAll('[data-filter]').forEach((button) =>
        button.addEventListener('click', () => this.setFilter(button))
      );
      this.querySelector('[data-more]')?.addEventListener('click', () => {
        this.limit += this.batch;
        this.apply(true);
      });
      this.items.forEach((item) =>
        item.querySelector('[data-open-index]')?.addEventListener('click', (event) => this.open(item, event.currentTarget))
      );
      this.dialog?.querySelectorAll('[data-step]').forEach((button) =>
        button.addEventListener('click', () => this.step(Number(button.dataset.step)))
      );
      this.dialog?.addEventListener('keydown', (event) => {
        const rtl = getComputedStyle(this).direction === 'rtl';
        if (event.key === 'ArrowRight') this.step(rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') this.step(rtl ? 1 : -1);
      });
      this.apply(false);
    }

    visibleItems() {
      return this.items.filter((item) => !this.filter || item.dataset.category === this.filter);
    }

    setFilter(button) {
      this.filter = button.dataset.filter;
      this.limit = this.batch;
      this.querySelectorAll('[data-filter]').forEach((el) => {
        const active = el === button;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-pressed', String(active));
      });
      this.apply(false);
    }

    apply(focusNew) {
      const matching = this.visibleItems();
      const firstNew = matching[this.limit - this.batch];
      this.items.forEach((item) => {
        const index = matching.indexOf(item);
        item.hidden = index === -1 || index >= this.limit;
        if (!item.hidden) item.classList.add('is-revealed');
      });
      const moreWrap = this.querySelector('[data-more-wrap]');
      if (moreWrap) moreWrap.hidden = matching.length <= this.limit;
      if (focusNew && firstNew) firstNew.querySelector('button')?.focus();
    }

    open(item, opener) {
      if (!this.dialog) return;
      this.current = this.visibleItems().filter((el) => !el.hidden).indexOf(item);
      this.render();
      window.Veloura.openDialog(this.dialog, opener);
    }

    step(direction) {
      const shown = this.visibleItems().filter((el) => !el.hidden);
      if (!shown.length) return;
      this.current = (this.current + direction + shown.length) % shown.length;
      this.render();
    }

    render() {
      const shown = this.visibleItems().filter((el) => !el.hidden);
      const item = shown[this.current];
      const template = item?.querySelector('[data-lightbox-item]');
      if (!template || !this.stage) return;
      const content = template.content.cloneNode(true);
      content.querySelectorAll('img').forEach((img) => img.setAttribute('loading', 'eager'));
      this.stage.replaceChildren(content);
      if (this.counter) {
        this.counter.textContent = this.counterTemplate
          .replace('[index]', this.current + 1)
          .replace('[count]', shown.length);
      }
      const single = shown.length < 2;
      this.dialog.querySelectorAll('[data-step]').forEach((button) => (button.hidden = single));
    }
  }
  if (!customElements.get('community-gallery')) customElements.define('community-gallery', CommunityGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab, false));
        tab.addEventListener('keydown', this.onKeydown);
      });
      this.closest('.featured-collection')?.addEventListener('shopify:block:select', (event) => {
        const tab = this.tabs.find((item) => item === event.target);
        if (tab) this.select(tab, false);
      });
    }

    onKeydown = (event) => {
      const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      const i = this.tabs.indexOf(event.currentTarget);
      const rtl = getComputedStyle(this).direction === 'rtl';
      let next = i;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.tabs.length - 1;
      else if ((event.key === 'ArrowRight') !== rtl) next = (i + 1) % this.tabs.length;
      else next = (i - 1 + this.tabs.length) % this.tabs.length;
      this.select(this.tabs[next], true);
    };

    select(tab, focus) {
      this.tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
      if (focus) tab.focus();
    }
  }
  if (!customElements.get('collection-tabs')) customElements.define('collection-tabs', CollectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProductForm extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('[data-featured-variant]');
      if (!select) return;
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const root = this.closest('.featured-product');
        const priceRegion = root?.querySelector('[data-featured-price]');
        const template = this.querySelector(`template[data-price-for="${option.value}"]`);
        if (priceRegion && template) priceRegion.replaceChildren(template.content.cloneNode(true));
        const button = this.querySelector('[data-featured-add]');
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.setAttribute('aria-disabled', String(!available));
        button.textContent = available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
      });
    }
  }
  if (!customElements.get('featured-product-form')) customElements.define('featured-product-form', FeaturedProductForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.sticky;
      this.group = this.closest('.shopify-section');
      this.lastY = this.clampedY();
      this.travel = 0;
      this.isStuck = false;
      this.isHidden = false;
      this.stickyTop = 0;
      this.updateHeight();
      this.resizeObserver = new ResizeObserver(() => this.updateHeight());
      this.resizeObserver.observe(this);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.updateHeight());

      if (this.group) this.group.classList.toggle('is-sticky-header', this.mode !== 'none');
      if (this.mode !== 'none') {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.addEventListener('focusin', this.onFocusIn);
        this.onScroll();
      }

      this.setupDropdowns();
      this.setupAccountFallback();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('focusin', this.onFocusIn);
      window.removeEventListener('pageshow', this.onPageShow);
      this.resizeObserver?.disconnect();
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('dialog:open', this.onDialogOpen);
    }

    updateHeight() {
      this.fitNav();
      // The sticky edge is 0 in a browser tab and the status bar height when the page
      // runs under it (safe-area-inset-top); the stuck state is measured against it.
      if (this.group) this.stickyTop = parseFloat(getComputedStyle(this.group).top) || 0;
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      this.updateOffset();
      if (this.dropdowns && window.innerWidth < 990) this.closeAll(true);
    }

    fitNav() {
      const header = this.querySelector('.header');
      const nav = this.querySelector('.header__nav');
      const menu = this.querySelector('.header__menu');
      const inner = this.querySelector('.header__inner');
      if (!header || !nav || !menu || !inner) return;
      if (window.innerWidth < 990) {
        header.classList.remove('is-nav-overflowing', 'is-nav-compact');
        return;
      }
      const logo = this.querySelector('.header__logo');
      const actions = this.querySelector('.header__actions');
      const fits = () => {
        const gap = parseFloat(getComputedStyle(inner).columnGap) || 0;
        const available = inner.clientWidth - (logo ? logo.offsetWidth : 0) - (actions ? actions.offsetWidth : 0) - gap * 2;
        return menu.scrollWidth <= available;
      };
      // Measure with the menu visible: full size first, then the compact step, then give up.
      header.classList.remove('is-nav-overflowing', 'is-nav-compact');
      if (fits()) return;
      header.classList.add('is-nav-compact');
      if (fits()) return;
      header.classList.remove('is-nav-compact');
      header.classList.add('is-nav-overflowing');
    }

    updateOffset() {
      const visible = this.mode !== 'none' && !this.isHidden;
      document.documentElement.style.setProperty('--header-offset', visible ? `${this.offsetHeight}px` : '0px');
    }

    /* Scroll position without the rubber band: iOS reports negative values at the top
       and values past the end at the bottom while it bounces, and both read as a change
       of direction. */
    clampedY() {
      const max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      return Math.min(Math.max(window.scrollY, 0), max);
    }

    onScroll = () => {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    };

    onFocusIn = () => this.setHidden(false);

    /* One state update per frame. Both states have hysteresis so nothing can toggle
       twice in a row from pointer jitter, sub-pixel scroll positions, momentum
       overshoot or the browser chrome collapsing on phones:
       - stuck: on once the section reaches the top edge, off only after it has moved a
         full pixel back down (or the page is at the very top);
       - hidden (scroll-up mode): the header only hides after 40px of continuous
         downward travel below the reveal line, and only shows after 16px of continuous
         upward travel. A change of direction resets the counter, so a quick back and
         forth never flips the state. Above the reveal line it is always shown. */
    update() {
      const y = this.clampedY();
      const delta = y - this.lastY;
      this.lastY = y;

      if (this.group) {
        const top = this.group.getBoundingClientRect().top - this.stickyTop;
        if (!this.isStuck && top <= 0.5 && y > 0) this.setStuck(true);
        else if (this.isStuck && (top > 1.5 || y <= 0)) this.setStuck(false);
      }

      if (this.mode !== 'scroll-up') return;
      if (y <= this.offsetHeight * 2) {
        this.travel = 0;
        this.setHidden(false);
        return;
      }
      if (this.querySelector('details[open]')) {
        this.travel = 0;
        return;
      }
      if (delta === 0) return;
      this.travel = Math.sign(delta) === Math.sign(this.travel) ? this.travel + delta : delta;
      if (this.travel > 40 && !this.isHidden) this.setHidden(true);
      else if (this.travel < -16 && this.isHidden) this.setHidden(false);
    }

    setStuck(stuck) {
      if (this.isStuck === stuck) return;
      this.isStuck = stuck;
      this.group?.classList.toggle('is-stuck', stuck);
    }

    setHidden(hidden) {
      if (this.isHidden === hidden) return;
      this.isHidden = hidden;
      this.group?.classList.toggle('is-hidden', hidden);
      this.updateOffset();
    }

    /* Desktop dropdowns and mega panels.
       Hover intent is tracked on the whole <li> (trigger, bridge and panel are all its
       descendants, so pointerleave only fires when the pointer really leaves the
       region). Opening waits a few milliseconds so a sweep across the bar does not
       flash every panel; closing waits longer and is cancelled on re-entry. The open
       attribute is removed only after the fade so the close is as smooth as the open. */
    setupDropdowns() {
      this.dropdowns = [...this.querySelectorAll('[data-nav-dropdown]')];
      if (!this.dropdowns.length) return;
      this.classList.add('is-enhanced');
      this.hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.timers = new Map();

      this.dropdowns.forEach((details) => {
        const entry = details.closest('li');
        const summary = details.querySelector('summary');

        details.addEventListener('toggle', () => {
          if (details.open) {
            this.dropdowns.forEach((other) => other !== details && this.close(other, true));
            window.requestAnimationFrame(() => {
              if (details.open) details.classList.add('is-visible');
            });
          } else {
            details.classList.remove('is-visible');
          }
        });

        summary.addEventListener('click', (event) => {
          if (!details.open) return;
          event.preventDefault();
          this.close(details);
        });

        entry.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch' || !this.hoverable.matches) return;
          this.clearTimer(details, 'close');
          this.clearTimer(details, 'finish');
          if (details.open) {
            details.classList.add('is-visible');
            return;
          }
          const switching = this.dropdowns.some((other) => other !== details && other.open);
          this.setTimer(details, 'open', () => this.open(details), switching ? 0 : 60);
        });

        entry.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'touch' || !this.hoverable.matches) return;
          this.clearTimer(details, 'open');
          if (details.open) this.setTimer(details, 'close', () => this.close(details), 220);
        });

        entry.addEventListener('focusout', (event) => {
          if (event.relatedTarget && entry.contains(event.relatedTarget)) return;
          if (details.open) this.close(details);
        });
      });

      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('dialog:open', this.onDialogOpen);
      window.addEventListener('pageshow', this.onPageShow);
      this.warmPanels();
    }

    /* Panel images are lazy in the markup so they never compete with the page, then
       they are fetched once the browser is idle so a panel opens fully drawn. */
    warmPanels() {
      const warm = () => {
        this.querySelectorAll('.nav-dropdown__panel img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
      };
      if (document.readyState === 'complete') {
        if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 2500 });
        else window.setTimeout(warm, 800);
      } else {
        window.addEventListener('load', () => window.setTimeout(warm, 400), { once: true });
      }
    }

    setTimer(details, name, callback, delay) {
      this.clearTimer(details, name);
      this.timers.set(`${name}:${this.dropdowns.indexOf(details)}`, window.setTimeout(callback, delay));
    }

    clearTimer(details, name) {
      const key = `${name}:${this.dropdowns.indexOf(details)}`;
      if (!this.timers.has(key)) return;
      window.clearTimeout(this.timers.get(key));
      this.timers.delete(key);
    }

    open(details) {
      this.clearTimer(details, 'close');
      this.clearTimer(details, 'finish');
      if (details.open) {
        details.classList.add('is-visible');
        return;
      }
      details.open = true;
    }

    close(details, immediate = false) {
      this.clearTimer(details, 'open');
      this.clearTimer(details, 'close');
      if (!details.open) return;
      details.classList.remove('is-visible');
      if (immediate || this.reduceMotion.matches) {
        this.clearTimer(details, 'finish');
        details.open = false;
        return;
      }
      this.setTimer(details, 'finish', () => (details.open = false), 220);
    }

    closeAll(immediate = false) {
      this.dropdowns.forEach((details) => this.close(details, immediate));
    }

    onDocumentClick = (event) => {
      this.dropdowns.forEach((details) => {
        if (details.open && !details.contains(event.target)) this.close(details);
      });
    };

    onKeydown = (event) => {
      if (event.key !== 'Escape') return;
      const open = this.dropdowns.find((details) => details.open);
      if (!open) return;
      this.close(open, true);
      open.querySelector('summary').focus();
    };

    onDialogOpen = () => this.closeAll(true);

    onPageShow = () => this.closeAll(true);

    setupAccountFallback() {
      const account = this.querySelector('shopify-account');
      const fallback = this.querySelector('.header__account-fallback');
      if (!account || !fallback) return;
      window.setTimeout(() => {
        if (!customElements.get('shopify-account')) {
          account.hidden = true;
          fallback.hidden = false;
        }
      }, 3000);
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      if (!this.input || this.dataset.enabled !== 'true') return;
      this.search = window.Veloura.debounce(() => this.fetchResults(), 250);
      this.input.addEventListener('input', this.search);
      this.addEventListener('keydown', this.onKeydown);
      this.closest('dialog')?.addEventListener('dialog:open', () => window.setTimeout(() => this.input.focus(), 30));
    }

    async fetchResults() {
      const query = this.input.value.trim();
      this.controller?.abort();
      if (query.length < 2) {
        this.results.innerHTML = '';
        this.status.textContent = '';
        return;
      }
      this.controller = new AbortController();
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('section_id', 'predictive-search');
      url.searchParams.set('resources[type]', 'product,collection,page,article,query');
      url.searchParams.set('resources[limit]', '4');
      url.searchParams.set('resources[limit_scope]', 'each');
      try {
        const response = await fetch(url.toString(), { signal: this.controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        const doc = window.Veloura.parseHTML(await response.text());
        const content = doc.querySelector('[data-predictive-content]');
        this.results.innerHTML = content ? content.outerHTML : '';
        const summary = content ? content.dataset.summary : '';
        this.status.textContent = summary || '';
      } catch (error) {
        if (error.name !== 'AbortError') this.results.innerHTML = '';
      }
    }

    onKeydown = (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const links = [...this.results.querySelectorAll('a')];
      if (!links.length) return;
      event.preventDefault();
      const index = links.indexOf(document.activeElement);
      let next;
      if (event.key === 'ArrowDown') next = index < 0 ? 0 : Math.min(links.length - 1, index + 1);
      else next = index <= 0 ? -1 : index - 1;
      if (next < 0) this.input.focus();
      else links[next].focus();
    };
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.counter = this.querySelector('[data-counter]');
      this.controls = this.querySelector('[data-controls]');
      this.live = this.querySelector('[data-live]');
      this.toggle = this.querySelector('[data-toggle]');
      this.index = 0;
      if (this.slides.length < 2) return;

      // Every control is optional (the merchant can hide any of them), so each
      // listener is attached only when its element was rendered.
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot), true)));
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.closest('input, textarea, select')) return;
        const rtl = document.documentElement.dir === 'rtl';
        const forward = (event.key === 'ArrowRight') !== rtl;
        event.preventDefault();
        this.go(this.index + (forward ? 1 : -1), true);
      });
      this.toggle?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        if (this.paused) this.stop();
        else this.start();
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      });
      this.addEventListener('shopify:block:select', (event) => {
        const i = this.slides.indexOf(event.target);
        if (i >= 0) this.go(i, false);
        this.paused = true;
        this.stop();
      });

      this.touchStart = null;
      this.addEventListener('touchstart', (event) => (this.touchStart = event.touches[0].clientX), { passive: true });
      this.addEventListener(
        'touchend',
        (event) => {
          if (this.touchStart === null) return;
          const delta = event.changedTouches[0].clientX - this.touchStart;
          this.touchStart = null;
          if (Math.abs(delta) < 40) return;
          const rtl = document.documentElement.dir === 'rtl';
          this.go(this.index + ((delta < 0) !== rtl ? 1 : -1), true);
        },
        { passive: true }
      );

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      const seconds = Number(this.dataset.autoplay) || 0;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!seconds || reduced || this.paused || window.Shopify?.designMode) return;
      this.stop();
      this.timer = window.setInterval(() => this.go(this.index + 1, false), seconds * 1000);
    }

    stop() {
      window.clearInterval(this.timer);
    }

    go(next, announce) {
      const count = this.slides.length;
      this.index = (next + count) % count;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('inert', !active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((dot, i) => {
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.counter) this.counter.textContent = String(this.index + 1).padStart(2, '0');
      if (this.controls) this.controls.style.setProperty('--slide-index', String(this.index));
      if (announce && this.live) this.live.textContent = this.slides[this.index].getAttribute('aria-label') || '';
    }
  }
  if (!customElements.get('hero-slideshow')) customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.removeAttribute('controls');
      this.toggle = this.closest('.hero')?.querySelector('[data-video-toggle]');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce.matches) {
        this.video.pause();
        this.video.removeAttribute('autoplay');
        this.setPressed(true);
      }
      this.toggle?.addEventListener('click', () => {
        if (this.video.paused) {
          this.video.play();
          this.setPressed(false);
        } else {
          this.video.pause();
          this.setPressed(true);
        }
      });
    }

    setPressed(paused) {
      this.toggle?.setAttribute('aria-pressed', paused ? 'true' : 'false');
    }
  }
  if (!customElements.get('hero-video')) customElements.define('hero-video', HeroVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspiration-board"] && !Shopify.designMode) return;
  try {
    
  class InspirationBoard extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('[data-filter]')];
      this.pins = [...this.querySelectorAll('[data-board] > .pin')];
      this.buttons.forEach((button) => button.addEventListener('click', () => this.filter(button)));
    }

    filter(active) {
      const value = active.dataset.filter;
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === active)));
      this.pins.forEach((pin) => {
        const tags = (pin.dataset.tags || '').split(' ');
        pin.hidden = value !== '' && !tags.includes(value) && pin.dataset.tags !== '';
      });
    }
  }
  if (!customElements.get('inspiration-board')) customElements.define('inspiration-board', InspirationBoard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class GridDensity extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.collection');
      this.buttons = [...this.querySelectorAll('[data-cols]')];
      let saved = null;
      try {
        saved = window.localStorage.getItem(this.dataset.storageKey);
      } catch (error) {
        saved = null;
      }
      if (saved) this.apply(saved);
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cols]');
        if (!button) return;
        this.apply(button.dataset.cols);
        try {
          window.localStorage.setItem(this.dataset.storageKey, button.dataset.cols);
        } catch (error) {
          /* Storage can be unavailable in private browsing. */
        }
      });
    }

    apply(cols) {
      if (!this.buttons.some((button) => button.dataset.cols === cols)) return;
      if (this.root) this.root.dataset.density = cols;
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.cols === cols)));
    }
  }
  if (!customElements.get('grid-density')) customElements.define('grid-density', GridDensity);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  (() => {
    const run = () => {
      const status = document.querySelector('[data-form-status]');
      if (!status) return;
      status.scrollIntoView({ block: 'center' });
      status.focus({ preventScroll: true });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  (() => {
    const run = () => {
      const dialog = document.getElementById('PasswordDialog');
      if (!dialog?.querySelector('[data-password-error]') || dialog.open) return;
      if (window.Veloura?.openDialog) {
        window.Veloura.openDialog(dialog);
      } else {
        dialog.showModal();
      }
      dialog.querySelector('input[type="password"]')?.focus();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ShareButton extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-share]')?.addEventListener('click', async () => {
        const url = this.dataset.url;
        const status = this.querySelector('[data-share-status]');
        if (navigator.share) {
          try {
            await navigator.share({ title: this.dataset.title, url });
          } catch (error) {
            /* Share dismissed. */
          }
          return;
        }
        try {
          await navigator.clipboard.writeText(url);
          if (status) status.textContent = this.dataset.copied;
          const label = this.querySelector('[data-share-label]');
          if (label) {
            const original = label.textContent;
            label.textContent = status.textContent;
            window.setTimeout(() => (label.textContent = original), 2500);
          }
        } catch (error) {
          window.prompt('', url);
        }
      });
    }
  }
  if (!customElements.get('share-button')) customElements.define('share-button', ShareButton);

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const doc = window.Veloura.parseHTML(await response.text());
        const selector = `[data-recommendations="${this.dataset.target}"]`;
        const incoming = doc.querySelector(selector);
        const current = this.querySelector(selector);
        if (incoming && current) {
          current.replaceWith(incoming);
          if (!incoming.children.length) this.classList.add('is-empty');
          window.Veloura.observeReveal?.(this);
        }
      } catch (error) {
        this.classList.add('is-empty');
      }
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      this.hidden = false;
      const main = document.querySelector('[data-main-add-button]');
      if (!main || !('IntersectionObserver' in window)) return;
      this.target = main.closest('[data-buy-buttons]') || main;
      this.footer = document.querySelector('.shopify-section-group-footer-group, footer');
      this.targetVisible = true;
      this.targetAbove = false;
      this.footerVisible = false;
      /* Two observers on the main buy buttons give the bar hysteresis: it hides as soon as
         any part of the buttons is on screen, but only shows once they have cleared the
         top of the viewport by a margin. Scrolling back and forth right at the edge can
         not make it blink. Jump scrolls and resizes are reported by the observers too. */
      this.hideObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this.targetVisible = entry.isIntersecting;
        /* A jump from below the buttons to above them (back to top, anchor links) does not
           cross the show observer's line, so read the position here as well. */
        if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) this.targetAbove = false;
        this.update();
      });
      this.showObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this.targetAbove = !entry.isIntersecting && entry.boundingClientRect.bottom <= 40;
        this.update();
      }, { rootMargin: '-40px 0px 0px 0px' });
      this.hideObserver.observe(this.target);
      this.showObserver.observe(this.target);
      if (this.footer) {
        this.footerObserver = new IntersectionObserver((entries) => {
          this.footerVisible = entries[0].isIntersecting;
          this.update();
        });
        this.footerObserver.observe(this.footer);
      }
    }

    disconnectedCallback() {
      this.hideObserver?.disconnect();
      this.showObserver?.disconnect();
      this.footerObserver?.disconnect();
      document.body.classList.remove('has-sticky-buy-bar');
    }

    update() {
      const show = this.targetAbove && !this.targetVisible && !this.footerVisible;
      if (show === this.classList.contains('is-visible')) return;
      if (show) this.clearCornerWidget();
      this.classList.toggle('is-visible', show);
      this.inert = !show;
      document.body.classList.toggle('has-sticky-buy-bar', show);
      document.documentElement.style.setProperty('--sticky-buy-bar-height', `${this.offsetHeight + 12}px`);
    }

    /* Shorten the bar when another fixed widget (chat launcher, WhatsApp button) sits in
       the bottom end corner of the viewport. The theme's own contact bubble moves itself. */
    clearCornerWidget() {
      const rtl = document.documentElement.dir === 'rtl';
      const x = rtl ? 28 : window.innerWidth - 28;
      const y = window.innerHeight - 28;
      const hit = document.elementsFromPoint(x, y).find((el) => {
        if (el === this || this.contains(el) || el.closest('.floating-contact')) return false;
        if (el === document.documentElement || el === document.body) return false;
        const position = getComputedStyle(el).position;
        return position === 'fixed' || !!el.closest('[style*="position: fixed"], [style*="position:fixed"]');
      });
      this.classList.toggle('sticky-buy-bar--clear-end', !!hit);
    }
  }
  if (!customElements.get('sticky-buy-bar')) customElements.define('sticky-buy-bar', StickyBuyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services"] && !Shopify.designMode) return;
  try {
    
  class ServiceList extends HTMLElement {
    connectedCallback() {
      this.rows = [...this.querySelectorAll('.svc')];
      this.images = [...this.querySelectorAll('.svc-visual__image')];
      this.images.forEach((image, i) => {
        const match = [...image.classList].find((name) => name.startsWith('svc-visual__image--'));
        image.dataset.index = match ? match.split('--')[1] : String(i);
      });
      this.rows.forEach((row) => {
        row.addEventListener('pointerenter', () => this.activate(row));
        row.addEventListener('focusin', () => this.activate(row));
      });
      this.addEventListener('shopify:block:select', (event) => {
        const row = event.target.closest('.svc');
        if (row) this.activate(row);
      });
      if (this.rows[0]) this.activate(this.rows[0]);
    }

    activate(row) {
      const index = row.dataset.index;
      this.rows.forEach((item) => item.classList.toggle('is-active', item === row));
      const hasMatch = this.images.some((image) => image.dataset.index === index);
      this.images.forEach((image, i) => {
        image.classList.toggle('is-active', hasMatch ? image.dataset.index === index : i === 0);
      });
    }
  }
  if (!customElements.get('service-list')) customElements.define('service-list', ServiceList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  class ShopTheLook extends HTMLElement {
    connectedCallback() {
      this.spots = [...this.querySelectorAll('.hotspot')];
      this.callouts = [...this.querySelectorAll('.look__callout')];
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;
      this.spots.forEach((spot) => spot.addEventListener('click', () => this.show(Number(spot.dataset.index))));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.spots.indexOf(event.target);
        if (index >= 0) this.show(index);
      });
    }

    show(index) {
      const item = this.track.children[index];
      if (!item) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      this.setActive(index);
    }

    onScroll = () => {
      /* Card pitch (width plus gap) rather than the track width, so partial-width cards
         and the peeking next card map to the right hotspot. */
      const first = this.track.children[0];
      const second = this.track.children[1];
      const pitch = second ? second.offsetLeft - first.offsetLeft : first?.offsetWidth || 1;
      const index = Math.round(Math.abs(this.track.scrollLeft) / Math.max(pitch, 1));
      this.setActive(Math.min(index, this.spots.length - 1));
    };

    setActive(index) {
      this.spots.forEach((spot, i) => {
        spot.classList.toggle('is-active', i === index);
        spot.setAttribute('aria-pressed', String(i === index));
      });
      this.callouts.forEach((callout, i) => {
        callout.classList.toggle('is-active', i === index);
        if (callout.tagName === 'A') callout.tabIndex = i === index ? 0 : -1;
      });
    }
  }
  if (!customElements.get('shop-the-look')) customElements.define('shop-the-look', ShopTheLook);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
  class VideoReel extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-reel-toggle]');
      this.label = this.querySelector('[data-reel-label]');
      if (!this.video || !this.toggle) return;
      this.video.removeAttribute('controls');
      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        this.video.paused ? this.play() : this.pause();
      });
      this.video.addEventListener('pause', () => this.sync());
      this.video.addEventListener('play', () => this.sync());
      this.setupAutoplay();
    }

    setupAutoplay() {
      if (!this.hasAttribute('data-autoplay') || !('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.video.muted = true;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              if (!this.userPaused) this.video.play().catch(() => {});
            } else if (!this.video.paused) {
              this.video.pause();
            }
          });
        },
        { threshold: [0, 0.6] }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    play() {
      if (!this.hasAttribute('data-autoplay')) {
        document.querySelectorAll('video-reel').forEach((reel) => {
          if (reel !== this && !reel.hasAttribute('data-autoplay')) reel.pause?.();
        });
      }
      this.video.play().catch(() => {});
    }

    pause() {
      this.video?.pause();
    }

    sync() {
      const playing = !this.video.paused;
      this.toggle.setAttribute('aria-pressed', String(playing));
      if (this.label) this.label.textContent = playing ? this.label.dataset.pause : this.label.dataset.play;
    }
  }
  if (!customElements.get('video-reel')) customElements.define('video-reel', VideoReel);

  } catch(e) { console.error(e); }
})();
})();
